import { Actions } from './Actions';
import { Footer } from './Footer';
import { Main } from './Main';
import { RightPanel } from './RightPanel';
import { TopNavigation } from './TopNavigation';
export const WizardSlot = { Actions, Footer, Main, RightPanel, TopNavigation };
